import BaseApi from "./BaseApi";

export default class Feature extends BaseApi{
    construct() {}

    static async search(params) {
        return await Feature.getAxiosInstance().get(Feature.getApiUrl(),{params: params});
    }

    static async create(params) {
        return await Feature.getAxiosInstance().post(Feature.getApiUrl(),params);
    }

    static async update(params, id) {
        return await Feature.getAxiosInstance().put(Feature.getApiUrl() + id,params);
    }

    static async delete(id) {
        return await Feature.getAxiosInstance().delete(Feature.getApiUrl() + id);
    }

    static async find(id) {
        return await Feature.getAxiosInstance().get(Feature.getApiUrl() + id);
    }

    static async list(params) {
        let url = Feature.getApiUrl() + "list";

        return Feature.getAxiosInstance().get(url,{params: params});
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/admin/c4/features/";
    }
}